<script>
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";
    import { generateRandomId } from "../utils/IdentifierGenerator.js";

    /**
 *
 *
 *
 */
    /**
 *
 */

    let { energyEfficiencyClasses, isBrand } = $props();
    let tileDimensions = getContext(cinemaTileDimensionCtxKey);
    let randomSheetId = generateRandomId();
    let eecComponentId = generateRandomId();

    let sheetsMovedOutsideTheComponent = [];
    const takeOutNestedEECSheets = (eecSheetId) => {
        const eecSheet = document.getElementById(eecSheetId);
        if (sheetsMovedOutsideTheComponent.includes(eecSheet)) return;
        const parentSheet = eecSheet.parentElement.closest("oc-sheet-v1");
        if (parentSheet) {
            parentSheet.parentElement.appendChild(eecSheet);
            sheetsMovedOutsideTheComponent.push(eecSheet);
            eecSheet.addEventListener("oc-sheet-after-close", () => {
                sheetsMovedOutsideTheComponent.forEach((eecSheet) => eecSheet.remove());
            });
        }
    };
</script>

<div class="reco_cinema__article-eek-container reco_cinema__article-eek">
    {#each energyEfficiencyClasses as energyEfficiencyClass, index}
        <oc-sheet-v1
            id="ft6bcn-eec-sheet-{index}-{randomSheetId}"
            headline="Energieeffizienzklasse {energyEfficiencyClass.component}"
            headline-level={3}
        >
            {#if !energyEfficiencyClass.images[0].uriTemplate}
                <div class="reco_cinema__article-eek-layer-container">
                    <p class="oc-copy-100">
                        Aktuell stehen leider keine weiteren Informationen zur Energieeffizienzklasse dieses Artikels zur Verfügung.
                    </p>
                </div>
            {:else}
                <div class="">
                    {#if energyEfficiencyClass.component || energyEfficiencyClass.dataSheetHref}
                        <div class="oc-px-100" style="max-height: calc(-160px + 100vh);">
                            <div class="reco_cinema____sheet-image-container">
                                <img
                                    class="reco_cinema__sheet-image"
                                    src={energyEfficiencyClass.images[0].uriTemplate}
                                    alt="Energieeffizienzklasse: "
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        {#if energyEfficiencyClass.dataSheetHref}
                            <oc-button-v1
                                variant="secondary"
                                target="_blank"
                                size="100"
                                base64-href={btoa(energyEfficiencyClass.dataSheetHref)}
                            >
                                <a href={energyEfficiencyClass.dataSheetHref}>Produktdatenblatt (PDF)</a>
                            </oc-button-v1>
                        {/if}
                    {/if}
                </div>
            {/if}
        </oc-sheet-v1>
        <div
            class="reco_cinema__article-eek-label oc-mt-25"
            onfocusin={() => takeOutNestedEECSheets(`ft6bcn-eec-sheet-${index}-${randomSheetId}`)}
        >
            <oc-interactive-overlay-v1 data-oc-sheet-v1-open data-oc-sheet-v1-open.id="ft6bcn-eec-sheet-{index}-{randomSheetId}">
                <ofc-energy-label-v1
                    id="{index}-{eecComponentId}"
                    class="reco_cinema__article-eek-label-img"
                    color={energyEfficiencyClass.colorHexCode}
                    size="100"
                    variant={energyEfficiencyClass.category}
                    version={energyEfficiencyClass.uniform ? "uniform" : "default"}
                    data-testid="EEC_energy_label"
                ></ofc-energy-label-v1>
            </oc-interactive-overlay-v1>

            {#if energyEfficiencyClass.dataSheetHref}
                <div class="reco_cinema__article-eek-label_energyLabelText">
                    {#if energyEfficiencyClass.displayName}
                        <span class="oc-copy-50 reco_cinema__article-eek-label_energyLabelText_energyLabelTextComponent">
                            {energyEfficiencyClass.displayName}
                        </span>
                    {/if}
                    <oc-link-v2
                        variant="secondary"
                        class="oc-link-v1 oc-link-v1--size-50 oc-link-v1--secondary reco_cinema__article-eek-label_energyLabelText_datasheet"
                        size="50"
                        style:max-width={isBrand ? `${tileDimensions.width - 51}px` : ""}
                    >
                        <a href={energyEfficiencyClass.dataSheetHref} target="_blank" rel="noopener noreferrer"> Produktdatenblatt </a>
                    </oc-link-v2>
                </div>
            {/if}
        </div>
    {/each}
</div>

<style lang="scss">
    .reco_cinema__article-eek-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .reco_cinema__article-eek-label {
        white-space: nowrap;
        display: flex;
        align-items: center;
        width: 100%;

        &_energyLabelText {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: calc(100% - 40px);

            &_energyLabelTextComponent {
                cursor: default;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-left: 4px;
                width: 100%;
                height: var(--oc-semantic-spacing-75);
            }

            &_datasheet {
                margin-left: 4px;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }

    .reco_cinema__article-eek-label:first-of-type {
        margin-top: unset !important;
    }

    :global(.reco_cinema__article-eek-layer-container) {
        margin: 16px auto;
        text-align: center;

        :global(.reco_cinema__article-eek-layer-title) {
            font-weight: 400;
            font-size: 20px;
            text-align: left;
            padding-left: 16px;
        }

        :global(.reco_cinema__article-eek-layer-datasheet) {
            text-align: left;
            display: block;
            padding-left: 16px;
        }

        :global(.reco_cinema__article-eek-layer-label) {
            margin-bottom: 16px;
        }

        :global(.reco_cinema__article-eek-layer-labels-container) {
            margin-bottom: 24px;
        }
    }

    .reco_cinema____sheet-image-container {
        display: flex;
        justify-content: center;
    }

    .reco_cinema__sheet-image {
        width: 100%;
    }
</style>
